export const season1 = [
  {
    episode: 1,
    vimeo: 569470745,
    season: 1,
  },
  {
    episode: 2,
    vimeo: 571215263,
    season: 1,
  },
  {
    episode: 3,
    vimeo: 571238022,
    season: 1,
  },
  {
    episode: 4,
    vimeo: 571775612,
    season: 1,
  },
  {
    episode: 5,
    vimeo: 572088280,
    season: 1,
  },
  {
    episode: 6,
    vimeo: 572097748,
    season: 1,
  },
  {
    episode: 7,
    vimeo: 572115409,
    season: 1,
  },
  {
    episode: 8,
    vimeo: 572121291,
    season: 1,
  },
  {
    episode: 9,
    vimeo: 572562109,
    season: 1,
  },
  {
    episode: 10,
    vimeo: 572570067,
    season: 1,
  },
  {
    episode: 11,
    vimeo: 572576294,
    season: 1,
  },
  {
    episode: 12,
    vimeo: 572585722,
    season: 1,
  },
  {
    episode: 13,
    vimeo: 572593588,
    season: 1,
  },
];

export const season2 = [
  {
    episode: 1,
    vimeo: 572614308,
    season: 2,
  },
  {
    episode: 2,
    vimeo: 572627650,
    season: 2,
  },
  {
    episode: 3,
    vimeo: 572649821,
    season: 2,
  },
  {
    episode: 4,
    vimeo: 572951361,
    season: 2,
  },
  {
    episode: 5,
    vimeo: 572962686,
    season: 2,
  },
  {
    episode: 6,
    vimeo: 572972420,
    season: 2,
  },
  {
    episode: 7,
    vimeo: 572987842,
    season: 2,
  },
  {
    episode: 8,
    vimeo: 572993486,
    season: 2,
  },
  {
    episode: 9,
    vimeo: 572999583,
    season: 2,
  },
];

export const season3 = [
  {
    episode: 1,
    vimeo: 573107603,
    season: 3,
  },
  {
    episode: 2,
    vimeo: 573293872,
    season: 3,
  },
  {
    episode: 3,
    vimeo: 573296956,
    season: 3,
  },
  {
    episode: 4,
    vimeo: 573300927,
    season: 3,
  },
  {
    episode: 5,
    vimeo: 573305219,
    season: 3,
  },
  {
    episode: 6,
    vimeo: 573309153,
    season: 3,
  },
  {
    episode: 7,
    vimeo: 573312649,
    season: 3,
  },
  {
    episode: 8,
    vimeo: 573334686,
    season: 3,
  },
];
export const season4 = [
  {
    episode: 1,
    vimeo: 573345408,
    season: 4,
  },
  {
    episode: 2,
    vimeo: 573349185,
    season: 4,
  },
  {
    episode: 3,
    vimeo: 573352690,
    season: 4,
  },
  {
    episode: 4,
    vimeo: 573364903,
    season: 4,
  },
  {
    episode: 5,
    vimeo: 573375223,
    season: 4,
  },
  {
    episode: 6,
    vimeo: 573380272,
    season: 4,
  },
  {
    episode: 7,
    vimeo: 573384858,
    season: 4,
  },
  {
    episode: 8,
    vimeo: 573394880,
    season: 4,
  },
];
